<template>
  <div class="productSelection">
    <div class="meter-title">
      需求详情
      <el-tag
        size="mini"
        effect="plain"
        :style="`color:${getColor(detailObj.status)};border-color:${getColor(
          detailObj.status
        )};margin-left:10px;font-weight: 500`"
        >{{ detailObj.statusStr }}</el-tag
      >
    </div>
    <div class="meter-info" v-loading="dataLoading">
      <div class="meter-info-left">
        <div class="meter-subtitle">基本信息</div>
        <div class="meter-info-base">
          <div class="meter-info-item">
            <div class="item-label">客户名称:</div>
            <div class="item-value">
              <Tooltips :innerContent="detailObj.companyName || '-'" />
            </div>
          </div>
          <div class="meter-info-item">
            <div class="item-label">
              <Tooltips :innerContent="detailObj.categoryLevelTitle1 || '-'" />:
            </div>
            <div class="item-value">
              <Tooltips :innerContent="detailObj.categoryName1 || '-'" />
            </div>
          </div>
          <div class="meter-info-item">
            <div class="item-label">
              <Tooltips :innerContent="detailObj.categoryLevelTitle2 || '-'" />:
            </div>
            <div class="item-value">
              <Tooltips :innerContent="detailObj.categoryName2 || '-'" />
            </div>
          </div>
          <div class="meter-info-item">
            <div class="item-label">
              <Tooltips :innerContent="detailObj.categoryLevelTitle3 || '-'" />:
            </div>
            <div class="item-value">
              <Tooltips :innerContent="detailObj.categoryName3 || '-'" />
            </div>
          </div>
          <div class="meter-info-item">
            <div class="item-label">仪表类型:</div>
            <div class="item-value">
              <Tooltips :innerContent="detailObj.instruType || '-'" />
            </div>
          </div>
          <div class="meter-info-item">
            <div class="item-label">产品偏好:</div>
            <div class="item-value">
              <Tooltips :innerContent="detailObj.preferType || '-'" />
            </div>
          </div>
          <div class="meter-info-item">
            <div class="item-label">用户名称:</div>
            <div class="item-value">
              <Tooltips :innerContent="detailObj.createUserName || '-'" />
            </div>
          </div>
          <div class="meter-info-item">
            <div class="item-label">创建时间:</div>
            <div class="item-value">
              <Tooltips :innerContent="detailObj.createTime || '-'" />
            </div>
          </div>
          <div class="meter-info-item">
            <div class="item-label">需求单号:</div>
            <div class="item-value">
              <Tooltips :innerContent="detailObj.demandNo || '-'" />
            </div>
          </div>
          <div class="meter-info-item half75">
            <div class="item-label">联系我们:</div>
            <div class="item-value">
              <Tooltips :innerContent="detailObj.dockTel || '-'" />
            </div>
          </div>
          <div class="meter-info-item">
            <div class="item-label">需求附件:</div>
            <div class="item-value visible">
              <el-badge :value="1" v-if="detailObj.demandAttachmentUrl">
                <div
                  class="attach-file"
                  @click="openFile(detailObj.demandAttachmentUrl)"
                >
                  <img src="@/assets/img/meterSelection/pin.png" />
                  附件
                </div>
              </el-badge>
              <span v-else>-</span>
            </div>
          </div>
          <div class="meter-info-item">
            <div class="item-label">设计附件:</div>
            <div class="item-value visible">
              <el-badge :value="1" v-if="detailObj.designAttachmentUrl">
                <div
                  class="attach-file"
                  @click="openFile(detailObj.designAttachmentUrl)"
                >
                  <img src="@/assets/img/meterSelection/pin.png" />
                  附件
                </div>
              </el-badge>
              <span v-else>-</span>
            </div>
          </div>
        </div>
        <div class="meter-config">
          <div class="meter-subtitle">参数配置</div>
          <div class="meter-tabs">
            <div
              class="meter-tab"
              v-for="(item, index) in tabs"
              :key="index"
              :class="{ active: item.code === activeIndex }"
              @click="changeTab(item)"
            >
              {{ item.name }}
            </div>
          </div>
          <!-- 需求参数 -->
          <div class="demand-table" v-show="activeIndex === '01'">
            <el-table
              style="width: 100%"
              border
              ref="table"
              :summary-method="summaryMethod"
              :show-summary="true"
              :cell-class-name="cellClassName"
              :span-method="arraySpanMethod"
              :data="dataList"
              :height="520"
            >
              <el-table-column
                width="65"
                align="center"
                show-overflow-tooltip
                property="attrGroupName"
                label="参数组"
                :resizable="false"
              ></el-table-column>
              <el-table-column
                min-width="100"
                align="center"
                show-overflow-tooltip
                property="attrName"
                label="参数名称"
                :resizable="false"
              ></el-table-column>
              <el-table-column
                min-width="100"
                align="center"
                show-overflow-tooltip
                property="attrValue"
                label="参数值"
                :resizable="false"
              >
              </el-table-column>
              <el-table-column
                min-width="100"
                align="center"
                show-overflow-tooltip
                property="unit"
                label="单位"
                :resizable="false"
              ></el-table-column>
            </el-table>
          </div>
          <!-- 设计参数 -->
          <div class="design-table" v-show="activeIndex === '02'">
            <el-table
              style="width: 100%"
              border
              ref="combineTable"
              :summary-method="designSummaryMethod"
              :show-summary="true"
              :cell-class-name="cellClassName"
              :span-method="designArraySpanMethod"
              :data="designList"
              :height="520"
            >
              <el-table-column
                width="65"
                align="center"
                show-overflow-tooltip
                property="attrGroupName"
                label="参数组"
                :resizable="false"
              ></el-table-column>
              <el-table-column
                min-width="100"
                align="center"
                show-overflow-tooltip
                property="attrName"
                label="参数名称"
                :resizable="false"
              ></el-table-column>
              <el-table-column
                min-width="100"
                align="center"
                show-overflow-tooltip
                property="attrValue"
                label="参数值"
                :resizable="false"
              >
              </el-table-column>
              <el-table-column
                min-width="100"
                align="center"
                show-overflow-tooltip
                property="unit"
                label="单位"
                :resizable="false"
              ></el-table-column>
            </el-table>
          </div>
          <!-- 推荐商品 -->
          <div class="recommend-goods" v-if="activeIndex === '03'">
            <div class="recommend-item">
              <div class="item-label">商品名称：</div>
              <div class="item-value">
                {{ recommendGoodsVo.goodsName }}
              </div>
            </div>
            <div class="recommend-item">
              <div class="item-label">品牌：</div>
              <div class="item-value">
                {{ recommendGoodsVo.brandName }}
              </div>
            </div>
            <div class="recommend-item">
              <div class="item-label">型号：</div>
              <div class="item-value">
                {{ recommendGoodsVo.model }}
              </div>
            </div>
            <div class="recommend-item">
              <div class="item-label">详细配置：</div>
              <div class="item-value">
                {{ recommendGoodsVo.configuration }}
              </div>
            </div>
            <div class="recommend-item">
              <div class="item-label">销售单位：</div>
              <div class="item-value">
                {{ recommendGoodsVo.sellingUnit }}
              </div>
            </div>
            <div class="recommend-item">
              <div class="item-label">销售价格：</div>
              <div class="item-value">
                {{
                  recommendGoodsVo.sellingPrice === 0
                    ? "￥0"
                    : recommendGoodsVo.sellingPrice
                    ? `￥${recommendGoodsVo.sellingPrice}`
                    : ""
                }}
              </div>
            </div>
            <div class="recommend-item">
              <div class="item-label">货期(天)：</div>
              <div class="item-value">
                {{ recommendGoodsVo.deliveryDate }}
              </div>
            </div>
            <div class="recommend-item">
              <div class="item-label">推荐理由：</div>
              <div class="item-value">
                {{ recommendGoodsVo.recommendedReason }}
              </div>
            </div>
            <div class="recommend-item">
              <div class="item-label">上传图片：</div>
              <div class="item-value no-scroll">
                <el-image
                  v-for="(item, index) in recommendGoodsVo.pictureUrlList"
                  :initial-index="findImgIndex(item)"
                  :key="index"
                  fit="contain"
                  style="width: 100px; height: 100px"
                  :src="
                    isPdfFile(item) ? require('@/assets/img/pdf.jpg') : item
                  "
                  @click="openPdf(item)"
                  :preview-src-list="removePdfImgs(item)"
                >
                </el-image>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="meter-info-right" v-if="detailObj.status === 2">
        <!-- 待确认才有审核 -->
        <div class="meter-subtitle">审核</div>
        <div class="btn-default" @click="dialogVisible = true">拒绝</div>
        <div class="btn-default btn-primary" @click="onConfirm">确认</div>
      </div>
    </div>

    <!-- 拒绝弹窗 -->
    <el-dialog
      title="温馨提示"
      :visible.sync="dialogVisible"
      width="420px"
      custom-class="comfirm-dialog"
      :close-on-click-modal="false"
      :before-close="handleClose"
    >
      <div class="dialog-content">
        请再次确认是否拒绝设计方案，拒绝后不可撤回。
      </div>
      <el-form
        :model="dataForm"
        :rules="rules"
        ref="input"
        v-loading="dialogLoading"
      >
        <el-form-item label="拒绝原因：" prop="refuseReason">
          <el-input
            type="textarea"
            show-word-limit
            maxlength="200"
            :autosize="{ minRows: 3, maxRows: 5 }"
            v-model.trim="dataForm.refuseReason"
            placeholder="请填写拒绝方案的原因"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button :disabled="dialogLoading" @click="handleClose"
          >取消</el-button
        >
        <el-button :loading="dialogLoading" type="primary" @click="submit"
          >确定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
import Tooltips from '@/components/tooltipShow'
import Vue from 'vue'

const Base64 = require('js-base64').Base64

const inquiryStatusList = [
  { value: '0', label: '待受理', color: '#8D8D19' },
  { value: '1', label: '设计中', color: '#26B2F2' },
  { value: '2', label: '待确认', color: '#F7AD53' },
  { value: '3', label: '已确认', color: '#85C02D' },
  { value: '4', label: '已拒绝', color: '#DE1E3A' },
  { value: '5', label: '未受理', color: '#909090' },
  { value: '6', label: '已取消', color: '#909090' }
]

export default {
  name: 'meterSelectionDetail', // 询价列表页
  components: {
    Tooltips
  },
  data () {
    return {
      dialogVisible: false,
      dialogLoading: false,
      dataForm: {
        demandId: '',
        refuseReason: ''
      },
      rules: {
        refuseReason: [
          { required: true, message: '请输入拒绝原因', trigger: 'change' }
        ]
      },
      tabs: [
        { name: '需求参数', code: '01' },
        { name: '设计参数', code: '02' },
        { name: '推荐商品', code: '03' }
      ],
      recommendGoodsVo: {}, // 推荐商品信息
      detailObj: {},
      activeIndex: '01',
      dataLoading: false,
      dataList: [], // 需求参数列表
      designList: [] // 设计参数列表
    }
  },
  created () {
    this.getDetail()
  },
  methods: {
    // 获取详情
    getDetail () {
      this.dataLoading = true
      this.$http
        .get(
          `/front/cross/commodity-user/design/demand/detail?demandId=${Base64.decode(
            this.$route.query.demandId
          )}`
        )
        .then(({ data: res }) => {
          if (res.code === 0) {
            this.detailObj = res.data
            this.recommendGoodsVo = res.data.recommendGoodsVo || {}

            // 组装需求参数
            this.addTableData()
            this.setTable()

            // 组装设计参数
            this.addDesignTableData()
            this.setCombineTable()
          }
        })
        .finally(() => {
          this.dataLoading = false
        })
    },
    // 打开附件
    openFile (file) {
      window.open(file)
    },
    // 切换tab查看内容
    changeTab (item) {
      if (this.activeIndex === item.code) return
      this.activeIndex = item.code

      // 初始化表格
      this.$nextTick(() => {
        this.$refs.table && this.$refs.table.doLayout()
        this.$refs.combineTable && this.$refs.combineTable.doLayout()
      })
    },
    /* --- 需求列表 START --- */

    // 组装table数据
    addTableData () {
      this.dataList = []
      this.detailObj.demandAttrVoList.forEach((item) => {
        this.dataList.push({
          attrGroupId: item.groupId,
          attrGroupName: item.groupName,
          ...item
        })
      })

      this.merage()
    },
    // 更新列表
    setTable () {
      this.$nextTick(() => {
        this.$refs.table && this.$refs.table.doLayout()
      })
    },
    // 表格参数组合并
    merage () {
      this.cghthArr = []
      let unikeyPos = 0
      for (let i = 0; i < this.dataList.length; i++) {
        // 第一行必须存在
        if (i === 0) {
          this.cghthArr.push(1)
        } else {
          // 判断当前元素与上一个元素cghth是否相同,并且uniKey是一样
          if (
            this.dataList[i].attrGroupId === this.dataList[i - 1].attrGroupId
          ) {
            this.cghthArr[unikeyPos] += 1
            this.cghthArr.push(0)
          } else {
            this.cghthArr.push(1)
            unikeyPos = i
          }
        }
      }
    },
    arraySpanMethod ({ row, column, rowIndex, columnIndex }) {
      // 操作列进行合并
      if (column.property === 'attrGroupName') {
        const row1 = this.cghthArr && this.cghthArr[rowIndex]
        return {
          rowspan: row1,
          colspan: 1
        }
      }
    },
    cellClassName ({ row, column, rowIndex, columnIndex }) {
      if (column.property === 'attrGroupName') {
        return 'vertical-rl'
      }
    },
    summaryMethod (param) {
      const { columns } = param
      const sums = []
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '其他'
          return
        }
        if (index === 1) {
          sums[index] = '备注'
          return
        }

        // 备注信息
        if (index !== 3) return

        // 表格行合并
        this.$nextTick(() => {
          const footer =
            this.$refs.table &&
            this.$refs.table.$el &&
            this.$refs.table.$el.querySelector('.el-table__footer')
          const hideCell =
            footer &&
            footer.querySelectorAll('td') &&
            footer.querySelectorAll('td')[2]
          const remarkCell =
            footer &&
            footer.querySelectorAll('td') &&
            footer.querySelectorAll('td')[3]

          if (hideCell) {
            hideCell.style.display = 'none'
          }

          if (remarkCell) {
            const cell = remarkCell.querySelector('.cell')
            remarkCell.setAttribute('colspan', 2)

            // 手动加入tooltips组件
            const h = this.$createElement
            const htmlVNode = h(
              'Tooltips',
              {
                class: 'ipt-noBorder',
                props: { innerContent: this.detailObj.userRemark || '' }
              },
              null
            )

            // 初始化实例加入dom中
            const html = new Vue({
              parent: this, // 保持上下文一致
              render: (h) => htmlVNode
            }).$mount()

            // 清空内容，防止重复
            cell.innerHTML = ''
            cell.appendChild(html.$el)
          }
        })
      })

      return sums
    },
    /* --- END --- */

    /* --- 需求列表 START --- */
    // 组装table数据
    addDesignTableData () {
      this.designList = []
      this.detailObj.designAttrVoList.forEach((item) => {
        this.designList.push({
          attrGroupId: item.groupId,
          attrGroupName: item.groupName,
          ...item
        })
      })

      this.designMerage()
    },
    // 更新列表
    setCombineTable () {
      this.$nextTick(() => {
        this.$refs.combineTable && this.$refs.combineTable.doLayout()
      })
    },
    // 表格参数组合并
    designMerage () {
      this.designArr = []
      let unikeyPos = 0
      for (let i = 0; i < this.designList.length; i++) {
        // 第一行必须存在
        if (i === 0) {
          this.designArr.push(1)
        } else {
          // 判断当前元素与上一个元素cghth是否相同,并且uniKey是一样
          if (
            this.designList[i].attrGroupId ===
            this.designList[i - 1].attrGroupId
          ) {
            this.designArr[unikeyPos] += 1
            this.designArr.push(0)
          } else {
            this.designArr.push(1)
            unikeyPos = i
          }
        }
      }
    },
    designArraySpanMethod ({ row, column, rowIndex, columnIndex }) {
      // 操作列进行合并
      if (column.property === 'attrGroupName') {
        const row1 = this.designArr && this.designArr[rowIndex]
        return {
          rowspan: row1,
          colspan: 1
        }
      }
    },
    designSummaryMethod (param) {
      const { columns } = param
      const sums = []
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '其他'
          return
        }
        if (index === 1) {
          sums[index] = '备注'
          return
        }

        // 备注信息
        if (index !== 3) return

        // 表格行合并
        this.$nextTick(() => {
          const footer =
            this.$refs.combineTable &&
            this.$refs.combineTable.$el &&
            this.$refs.combineTable.$el.querySelector('.el-table__footer')
          const hideCell =
            footer &&
            footer.querySelectorAll('td') &&
            footer.querySelectorAll('td')[2]
          const remarkCell =
            footer &&
            footer.querySelectorAll('td') &&
            footer.querySelectorAll('td')[3]

          if (hideCell) {
            hideCell.style.display = 'none'
          }

          if (remarkCell) {
            const cell = remarkCell.querySelector('.cell')
            remarkCell.setAttribute('colspan', 2)

            // 手动加入tooltips组件
            const h = this.$createElement
            const htmlVNode = h(
              'Tooltips',
              {
                class: 'ipt-noBorder',
                props: { innerContent: this.detailObj.designRemark || '' }
              },
              null
            )

            // 初始化实例加入dom中
            const html = new Vue({
              parent: this, // 保持上下文一致
              render: (h) => htmlVNode
            }).$mount()

            // 清空内容，防止重复
            cell.innerHTML = ''
            cell.appendChild(html.$el)
          }
        })
      })

      return sums
    },
    /* --- END --- */

    // 判断是否为pdf文件
    isPdfFile (file) {
      if (!file) return false
      const pdfRegex = /\.pdf$/i
      return file && pdfRegex.test(file)
    },
    // 移除pdf文件，只剩图片
    removePdfImgs (src) {
      if (this.isPdfFile(src)) return []
      const imgs = this.recommendGoodsVo.pictureUrlList || []
      return imgs.filter((item) => !this.isPdfFile(item))
    },
    // 找到图片在去除pdf文件列表中的序号
    findImgIndex (img) {
      return this.removePdfImgs().findIndex((item) => item === img)
    },
    // 打开pdf文件
    openPdf (src) {
      if (this.isPdfFile(src)) {
        window.open(src)
      }
    },
    // 需求确认二次提醒
    onConfirm () {
      this.$confirm(
        '请再次确认是否确认该设计方案，确认后我方商务人员将尽快与您联系，请注意接听来电。',
        '温馨提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          customClass: 'comfirm-box',
          type: 'warning'
        }
      ).then(() => {
        this.dataLoading = true
        this.$http
          .post(
            `/front/cross/commodity-user/design/demand/confirm?acceptResult=true&demandId=${Base64.decode(
              this.$route.query.demandId
            )}`
          )
          .then(({ data: { code } }) => {
            if (code === 0) {
              this.$message.success('操作成功')
              this.getDetail()
            } else {
              this.dataLoading = false
            }
          })
          .catch(() => {
            this.dataLoading = false
          })
      })
    },
    // 拒绝弹窗关闭
    handleClose () {
      this.$refs.input.resetFields()
      this.dialogVisible = false
    },
    // 拒绝原因提交
    submit () {
      this.$refs.input.validate((valid) => {
        if (valid) {
          this.dialogLoading = true
          this.$http
            .post(
              `/front/cross/commodity-user/design/demand/confirm?acceptResult=false&demandId=${Base64.decode(
                this.$route.query.demandId
              )}&refuseReason=${this.dataForm.refuseReason}`
            )
            .then(({ data: res }) => {
              if (res.code === 0) {
                this.handleClose()
                this.$message.success('操作成功')
                this.getDetail()
              }
            })
            .finally(() => {
              this.dialogLoading = false
            })
        }
      })
    },
    // 获取状态对应颜色
    getColor (status) {
      // eslint-disable-next-line eqeqeq
      const statusObj = inquiryStatusList.find((item) => item.value == status)
      return (statusObj && statusObj.color) || '#606266'
    }
  }
}
</script>

<style lang="scss"></style>

<style lang="scss" scoped>
.productSelection {
  .meter-title {
    font-size: 16px;
    font-weight: bold;
    color: #333333;
    margin-bottom: 32px;
  }

  .meter-subtitle {
    margin-bottom: 13px;
    padding-left: 8px;
    position: relative;
    font-size: 16px;
    font-weight: bold;
    line-height: 22px;
    color: #333333;

    &::after {
      content: "";
      position: absolute;
      left: 0;
      top: 50%;
      margin-top: -6px;
      height: 12px;
      width: 1px;
      background: #2a54d1;
    }
  }

  .meter-info {
    display: flex;

    &-left {
      width: 818px;
      margin-right: 40px;

      .meter-info-base {
        display: flex;
        flex-wrap: wrap;
        align-items: center;

        .meter-info-item {
          font-size: 14px;
          font-weight: 500;
          line-height: 19px;
          color: #333333;
          width: 25%;
          display: flex;
          white-space: nowrap;
          font-size: 14px;
          font-weight: 500;
          margin-bottom: 14px;

          &.half75 {
            width: 75%;
          }

          .item-label {
            display: flex;
            align-items: center;
            max-width: 50%;
          }

          .item-value {
            padding-left: 6px;
            overflow: hidden;

            &.visible {
              overflow: visible;
            }

            /deep/ .el-badge__content {
              pointer-events: none;
            }

            .attach-file {
              border: 1px solid #7394f6;
              border-radius: 8px;
              font-size: 10px;
              font-weight: 500;
              color: #7394f6;
              padding: 3px 8px;
              display: flex;
              align-items: center;
              cursor: pointer;

              img {
                margin-right: 4px;
                width: 12px;
              }
            }
          }
        }
      }

      .meter-config {
        margin-top: 18px;

        .meter-tabs {
          background: #f5f6fa;
          border-radius: 16px;
          display: inline-block;
          border: 2px solid #f5f6fa;
          margin-bottom: 13px;

          .meter-tab {
            margin-right: 4px;
            font-size: 12px;
            line-height: 16px;
            color: #666666;
            padding: 8px 16px;
            display: inline-block;
            cursor: pointer;
            user-select: none;

            &:last-child {
              margin-right: 0;
            }

            &.active {
              background: #fff;
              border-radius: 14px;
              font-weight: bold;
              color: #2a54d1;
            }
          }
        }
      }

      .el-table {
        border-radius: 8px;
        color: #3d3d3d;

        /deep/ .vertical-rl {
          writing-mode: vertical-rl;
          text-orientation: upright;

          .cell {
            min-width: auto;
            display: flex;
            align-items: center;
            justify-content: center;
            width: 100%;
          }
        }

        /deep/ th.el-table__cell {
          background-color: #2a54d1;
          font-weight: 500;
        }

        /deep/ thead {
          color: #fff;
        }

        /deep/ .el-table__footer-wrapper {
          tbody td.el-table__cell {
            background-color: #2a54d1;
            color: #fff;

            &:nth-child(4) {
              background: #fff;
            }

            .ipt-noBorder {
              width: 100%;
              height: 100%;
              border: none;
              color: #3d3d3d;
              text-align: left;
            }
          }
        }
      }

      .recommend-goods {
        // width: 50%;
        column-count: 2; /* 分两列 */
        column-gap: 40px; /* 列间距 */
        column-fill: auto; /* 自动平衡填充 */
        height: 520px; /* 需要指定高度触发分流 */

        .recommend-item {
          display: flex;
          align-items: flex-start;
          margin-bottom: 12px;

          .item-label {
            width: 70px;
            font-size: 14px;
            font-weight: 500;
            line-height: 19px;
            white-space: nowrap;
            color: #333333;
            // text-align: right;
          }

          .item-value {
            overflow-x: hidden;
            font-size: 12px;
            font-weight: normal;
            line-height: 19px;
            color: #333333;
            width: calc(100% - 70px);
            overflow-y: auto;
            max-height: 96px;
            word-break: break-all;

            &.no-scroll {
              max-height: none;
            }

            .el-image {
              padding: 5px;
              margin-right: 9px;
              border-radius: 8px;
              cursor: pointer;
              border: 1px dashed rgba(204, 204, 204, 0.4);

              &:last-child {
                margin-right: 0;
              }
            }
          }
        }
      }
    }

    &-right {
      width: calc(100% - 858px);

      .meter-subtitle {
        margin-bottom: 30px;
      }

      .btn-default {
        font-size: 14px;
        line-height: 20px;
        color: #333333;
        padding: 10px 30px;
        background: #f7f8fd;
        margin-bottom: 15px;
        border-radius: 12px;
        display: inline-block;
        cursor: pointer;

        &.btn-primary {
          background: #2a54d1;
          color: #ffffff;
        }
      }
    }
  }
}
</style>
